import _implicitStylesheets from "./recommendations.css";
import _implicitScopedStylesheets from "./recommendations.scoped.css?scoped=true";
import _amcTilesGrid from "amc/tilesGrid";
import _aceTooltip from "ace/tooltip";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span${3}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "reco_tooltip": true
  },
  slotAssignment: "tooltip_slot",
  key: 4
};
const stc1 = {
  classMap: {
    "tooltip-container": true
  },
  key: 5
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, k: api_key, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [$cmp.isEmpty ? $cmp.isError ? api_custom_element("amc-tiles-grid", _amcTilesGrid, {
    props: {
      "gridItemSize": $cmp.gridItemSize,
      "gridGap": "x-large",
      "gridAlignItems": "spread",
      "gridAxis": "row",
      "gridFlow": "wrap",
      "gridRowGap": "x-large",
      "isError": $cmp.isError
    },
    key: 0,
    on: {
      "retry": _m0 || ($ctx._m0 = api_bind($cmp.handleRetry))
    }
  }) : null : null, $cmp.isEmpty ? $cmp.isLoading ? api_custom_element("amc-tiles-grid", _amcTilesGrid, {
    props: {
      "gridItemSize": $cmp.gridItemSize,
      "gridGap": "x-large",
      "gridAlignItems": "spread",
      "gridAxis": "row",
      "gridFlow": "wrap",
      "gridRowGap": "x-large",
      "isLoading": $cmp.isLoading,
      "props": $cmp.props
    },
    key: 1
  }) : null : null, !$cmp.isEmpty ? api_element("div", {
    key: 2,
    on: {
      "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleAnalytics))
    }
  }, api_iterator($cmp.records, function (section) {
    return api_custom_element("amc-tiles-grid", _amcTilesGrid, {
      props: {
        "gridItemSize": $cmp.gridItemSize,
        "gridGap": "x-large",
        "gridAlignItems": "flex-start",
        "gridAxis": "row",
        "gridFlow": "wrap",
        "gridRowGap": "x-large",
        "props": section.props,
        "records": section.records,
        "isLoading": section.isLoading,
        "isError": section.isError
      },
      key: api_key(3, section.id),
      on: {
        "retry": _m2 || ($ctx._m2 = api_bind($cmp.handleRetry)),
        "navigate": _m3 || ($ctx._m3 = api_bind($cmp.handleNavigate))
      }
    }, [$cmp.hasTooltip ? api_element("span", stc0, [api_element("div", stc1, [api_static_fragment($fragment1, 7, [api_static_part(1, null, api_dynamic_text($cmp.labels.tooltipPreamble))]), api_custom_element("ace-tooltip", _aceTooltip, {
      props: {
        "tooltipData": section.props.tooltip,
        "popoverOrientation": $cmp.popoverOrientation
      },
      key: 8
    })])]) : null]);
  })) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4h87hlo4548";
tmpl.legacyStylesheetToken = "undefined-_recommendations";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
